import type {UserEventSpec, UserEventStruct} from '@cohort/shared/apps/userEvent';
import {z} from 'zod';

export const CohortContentCtaClickedPropertiesSchema = z.object({
  contentId: z.string().uuid(),
  contentInternalName: z.string(),
  contentMediaKind: z.string(),
  ctaUrl: z.string(),
});
export type CohortContentCtaClickedProperties = z.infer<
  typeof CohortContentCtaClickedPropertiesSchema
>;

export type CohortContentCtaClickedEventStruct = UserEventStruct<
  'cohort.content.cta-clicked',
  keyof CohortContentCtaClickedProperties,
  CohortContentCtaClickedProperties,
  CohortContentCtaClickedProperties
>;

export const CohortContentCtaClickedEventSpec: UserEventSpec<CohortContentCtaClickedEventStruct> = {
  id: 'cohort.content.cta-clicked',
  name: "Clicked on a Content's CTA",
  description: 'Event Triggerred when a user clicks on the CTA of a Content',
  propertiesSchema: CohortContentCtaClickedPropertiesSchema,
  exposedPropertiesSchema: CohortContentCtaClickedPropertiesSchema,
  resources: {
    contentId: 'cohort.content',
  },
  rulesEngineConfig: {
    isVisible: true,
    exposedFields: ['contentId', 'ctaUrl'],
  },
};
